<template>
    <div class="content-wrapper">
        <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
                            <li class="breadcrumb-item page-header d-flex align-items-center">
                                <h4 class="mb-0">{{ $t('jobPost.job_post_details') }}</h4>
                            </li>
                            <template v-if="this.$can('view_job_posts')">
                                <li class="ml-2">|</li>
                                <li>
                                    <a :href="urlGenerator(jobPostWebUrl)"
                                       class="btn btn-link text-primary pl-2">{{
                                            $t('jobPost.back_to_all_job_post')
                                        }}</a>
                                </li>
                            </template>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="d-flex justify-content-lg-end mb-primary">
                    <div class="dropdown">
                        <button type="button"
                                class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                            {{ $t('action') }}
                            <app-icon name="chevron-down"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item" @click="editJobPost">
                                {{ $t('edit') }}
                            </a>

                            <a href="#" class="dropdown-item" @click.prevent="deleteJobPost">
                                {{ $t('delete') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="job-post-profile mb-primary">
            <div class="card card-with-shadow py-5 border-0" style="min-height: 220px;">
                <app-overlay-loader v-if="loader"/>
                <div v-else class="row">
                    <!-- Left Section -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 job-post-header-media align-items-center">
                            <div class="media-body job-post-info-header">
                                <p class="text-muted mb-0">{{ $t('title') }}</p>
                                <p>{{ jobPost.title }}</p>
                            </div>
                        </div>

                        <div class="media border-right px-5 job-post-header-media align-items-center">
                            <div class="media-body job-post-info-header">
                                <p class="text-muted mb-0">{{ $t('description') }}</p>
                                <p>{{ jobPost.description }}</p>
                            </div>
                        </div>

                        <div class="media border-right px-5 job-post-header-media align-items-center">
                            <div class="align-self-center mr-3">
                                <app-icon name="users"/>
                            </div>
                            <div class="media-body job-post-info-header">
                                <p class="text-muted mb-0">{{ $t('vacancy') }}</p>
                                <p>{{ jobPost.vacancy }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Right Section -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div
                            class="job-post-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <!-- Left Column of Details -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="tag"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('job_position') }}</p>
                                                <p v-if="jobPost.job_position_id">{{ jobPost.job_position.title }}</p>
                                                <p v-else>{{ $t('not_added_yet') }}</p>
                                            </div>
                                        </div>

                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="user"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('manager') }}</p>
                                                <p v-if="jobPost.manager_id">{{ jobPost.manager.full_name }}</p>
                                                <p v-else>{{ $t('not_added_yet') }}</p>
                                            </div>
                                        </div>

                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('start_date') }}</p>
                                                <p>{{ formattedDate(jobPost.start_date) }}</p>
                                            </div>
                                        </div>

                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('end_date') }}</p>
                                                <p>{{ formattedDate(jobPost.end_date) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right Column of Additional Details -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <!-- Skill Section -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="star"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('skill') }}</p>
                                                <p v-if="jobPost.skill_id">{{ jobPost.skill.title }}</p>
                                                <p v-else>{{ $t('not_added_yet') }}</p>
                                            </div>
                                        </div>

                                        <!-- Is Published Section -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="check"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('published') }}</p>
                                                <p>{{ jobPost.is_published ? $t('yes') : $t('no') }}</p>
                                            </div>
                                        </div>

                                        <!-- Is Profile Section -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="user-check"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('profile') }}</p>
                                                <p>{{ jobPost.is_profile ? $t('yes') : $t('no') }}</p>
                                            </div>
                                        </div>

                                        <!-- Is Resume Section -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="file-text"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('resume') }}</p>
                                                <p>{{ jobPost.is_resume ? $t('yes') : $t('no') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-job-post-modal
            v-if="isJobPostModalActive"
            v-model="isJobPostModalActive"
            :selected-url="updateUrl"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import {axiosDelete, urlGenerator} from '../../../../../common/Helper/AxiosHelper';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import JobPostCreateEditModal from "../../Recruitment/JobPost/JobPostCreateEditModal"; // Adjust the path to match your file structure
import {formatDateTimeToLocalDate, formattedDate} from "../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {JOB_POST, JOB_POST_WEB} from "../../../../Config/ApiUrl"; // Adjust the API URLs accordingly

export default {
    name: "JobPostDetails",
    mixins: [FormMixin],
    components: {JobPostCreateEditModal},
    props: {
        jobPostId: {}
    },
    data() {
        return {
            jobPost: {},
            jobPostWebUrl: JOB_POST_WEB,
            urlGenerator,
            formatDateTimeToLocalDate,
            viewJobPostModal: false,
            isJobPostModalActive: false,
            confirmationModalActive: false,
            isJobPostNoteModalActive: false,
            deleteUrl: '',
            promptAction: '',
            updateUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            formattedDate
        };
    },
    mounted() {
        // Fetch job post details on component mount
        this.$store.dispatch("getJobPostDetails", this.jobPostId);
    },
    methods: {
        cancelled() {
            this.confirmationModalActive = false;
        },

        editJobPost() {
            this.updateUrl = `${JOB_POST}/${this.jobPostId}`;
            this.isJobPostModalActive = true;
        },

        // ✅ Delete job post functionality
        deleteJobPost() {
            this.confirmationModalActive = true;
            this.deleteUrl = `${JOB_POST}/${this.jobPostId}`;
            this.promptAction = 'delete_job_post';
            this.promptTitle = this.$t('are_you_sure');
            this.promptMessage = this.$t('jobPost.you_are_going_to_remove_a_job_post_from_list');
        },

        // ✅ Confirmation Modal Close
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            // ✅ Redirect using urlGenerator
            window.location.href = urlGenerator(`${JOB_POST_WEB}`);
        },

        // ✅ Handles confirm button in modal
        triggerConfirm() {
            if (this.promptAction === 'delete_job_post') {
                this.removeJobPost(this.deleteUrl);
            }
        },

        // ✅ Delete request
        removeJobPost(url) {
            this.loading = true;

            axiosDelete(url)
                .then(({data}) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'job-post-table');
                })
                .catch(({response}) => {
                    this.toastException(response.data);
                    this.confirmationModalActive = false;
                })
                .finally(() => this.closeConfirmation());
        }
    },
    computed: {
        ...mapState({
            JobPostDetails: state => state.jobPost.jobPost,
            loader: state => state.loading,
        }),
    },
    watch: {
        JobPostDetails: {
            handler: function (jobPost) {
                this.jobPost = jobPost;
                document.title = jobPost.title;
            },
            deep: true
        }
    }
};
</script>
